import { get } from 'lodash';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { historyActionEnum } from '@modules/trips/_tripsEnums';
import { formatToDecimals } from '@utils/utils';

export default [
  {
    label: 'Řidič',
    field: 'officer.name',
    displayField: 'officer',
    mapper: parent => get(parent, 'fullName'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Služební vozidlo',
    field: 'vehicle.name',
    displayField: 'vehicle',
    mapper: parent => get(parent, 'fullName'),
    type: ColumnType.TEXT,
    width: 200
  },
  {
    label: 'Začátek jízdy',
    field: 'startTime',
    type: ColumnType.DATETIME,
    width: 100,
    compact: true
  },
  {
    label: 'Konec jízdy',
    field: 'endTime',
    type: ColumnType.DATETIME,
    width: 100,
    compact: true
  },
  {
    label: 'Celkově čas',
    field: 'totalTime',
    type: ColumnType.JSX,
    jsx: ({ row }) => {
      if (!row.startTime || !row.endTime) {
        return '0';
      }

      const date1 = new Date(row.startTime).getTime();
      const date2 = new Date(row.endTime).getTime();

      const diffMs = date2 - date1;

      const totalMinutes = Math.floor(diffMs / (1000 * 60)); // Total minutes

      const hours = Math.floor(totalMinutes / 60); // Extract hours
      const minutes = totalMinutes % 60; // Extract remaining minutes

      return `${hours}h ${minutes}m`;
    },
    width: 100
  },
  {
    label: 'Předávka',
    field: 'transfer',
    type: ColumnType.TEXT,
    width: 200,
    compact: true
  },
  {
    label: 'Poznámka',
    field: 'note',
    mapper: note => (note && note.length > 200 ? note.substring(0, 200 - 3) + '...' : note),
    type: ColumnType.TEXT,
    width: 200,
    compact: true
  },
  {
    label: 'Počáteční nájezd',
    field: 'startMileage',
    type: ColumnType.NUMBER,
    width: 100
  },
  {
    label: 'Konečný nájezd',
    field: 'endMileage',
    type: ColumnType.NUMBER,
    width: 100
  },
  {
    label: 'Celkový nájezd',
    field: 'totalMileage',
    type: ColumnType.JSX,
    jsx: ({ row }) => (row.endMileage && row.startMileage ? row.endMileage - row.startMileage : ''),
    width: 100
  },
  {
    label: 'Nájezd',
    field: 'mileage',
    type: ColumnType.NUMBER,
    width: 100
  },
  {
    label: 'Natankované množství',
    field: 'refuelingAmount',
    type: ColumnType.NUMBER,
    width: 100
  },
  {
    label: 'Cena tankovaného paliva',
    field: 'refuelingPrice',
    type: ColumnType.NUMBER,
    width: 100,
    mapper: v => formatToDecimals(v)
  }
];

const NOTE_LENGTH = 30;

export const tripsHistoriesColumns = [
  {
    label: 'Text záznamu',
    field: 'note',
    displayField: 'note',
    mapper: note => (note && note.length > NOTE_LENGTH ? note.substring(0, NOTE_LENGTH - 3) + '...' : note),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Akce s jízdou',
    field: 'action',
    type: ColumnType.ENUM,
    enum: historyActionEnum,
    width: 100
  },
  {
    label: 'Uživatel, který akci provedl',
    field: 'employee.fullName',
    displayField: 'employee',
    mapper: parent => get(parent, 'fullName'),
    type: ColumnType.TEXT,
    width: 100
  }
];



// WEBPACK FOOTER //
// ./src/modules/trips/_tripsColumns.ts